import type * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthorDashboardRecentFeedbackQueryVariables = Types.Exact<{
  updatedSince: Types.Scalars['DateTime']['input'];
  userId: Types.Scalars['ID']['input'];
}>;


export type AuthorDashboardRecentFeedbackQuery = { __typename?: 'RootQueryType', authoringFeedbacks?: { __typename?: 'KeysetPageOfAuthoringFeedback', results?: Array<{ __typename?: 'AuthoringFeedback', id: string, message: string, questionId: string, updatedAt: any, userInfo?: { __typename?: 'AuthoringFeedbackUserInfo', firstName?: string | null, lastName?: string | null } | null, question: { __typename?: 'Question', id: string, title?: string | null, questionSetId?: string | null, unfilteredSubject: { __typename?: 'Subject', name: string } } }> | null } | null };


export const AuthorDashboardRecentFeedbackDocument = gql`
    query AuthorDashboardRecentFeedback($updatedSince: DateTime!, $userId: ID!) {
  authoringFeedbacks(
    filter: {updatedAt: {greaterThanOrEqual: $updatedSince}, question: {authorId: {eq: $userId}}}
    sort: [{field: UPDATED_AT, order: DESC}]
    first: 250
  ) {
    results {
      id
      message
      questionId
      updatedAt
      userInfo {
        firstName
        lastName
      }
      question {
        id
        title
        questionSetId
        unfilteredSubject {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAuthorDashboardRecentFeedbackQuery__
 *
 * To run a query within a React component, call `useAuthorDashboardRecentFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorDashboardRecentFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorDashboardRecentFeedbackQuery({
 *   variables: {
 *      updatedSince: // value for 'updatedSince'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAuthorDashboardRecentFeedbackQuery(baseOptions: Apollo.QueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables> & ({ variables: AuthorDashboardRecentFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>(AuthorDashboardRecentFeedbackDocument, options);
      }
export function useAuthorDashboardRecentFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>(AuthorDashboardRecentFeedbackDocument, options);
        }
// @ts-ignore
export function useAuthorDashboardRecentFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>;
export function useAuthorDashboardRecentFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorDashboardRecentFeedbackQuery | undefined, AuthorDashboardRecentFeedbackQueryVariables>;
export function useAuthorDashboardRecentFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>(AuthorDashboardRecentFeedbackDocument, options);
        }
export type AuthorDashboardRecentFeedbackQueryHookResult = ReturnType<typeof useAuthorDashboardRecentFeedbackQuery>;
export type AuthorDashboardRecentFeedbackLazyQueryHookResult = ReturnType<typeof useAuthorDashboardRecentFeedbackLazyQuery>;
export type AuthorDashboardRecentFeedbackSuspenseQueryHookResult = ReturnType<typeof useAuthorDashboardRecentFeedbackSuspenseQuery>;
export type AuthorDashboardRecentFeedbackQueryResult = Apollo.QueryResult<AuthorDashboardRecentFeedbackQuery, AuthorDashboardRecentFeedbackQueryVariables>;